import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MessageDetail {
  message: string | null;
  selfMessage: string | null;
  userId: string | null;
  createdTime: string;
  id: string | null;
}

interface BroadcastMessagesState {
  [auctionId: string]: MessageDetail[];
}

const initialState: BroadcastMessagesState = {};

const broadcastMessagesSlice = createSlice({
  name: 'broadcastMessages',
  initialState,
  reducers: {
    setBroadcastMessages: (
      state,
      action: PayloadAction<{ auctionId: string; messages: MessageDetail[] }>
    ) => {
      const { auctionId, messages } = action.payload;
      // Filter out duplicate messages
      const existingMessages = state[auctionId] || [];
      const allMessages = [...existingMessages, ...messages];
      const uniqueMessages = allMessages.filter((message, index, self) =>
        index === self.findIndex(
          m => m.message === message.message && 
               m.userId === message.userId && 
               m.createdTime === message.createdTime
        )
      );
      state[auctionId] = uniqueMessages;
    },
  },
});

export const { setBroadcastMessages } = broadcastMessagesSlice.actions;
export default broadcastMessagesSlice.reducer;
